function generateColor() {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
}

export const getRandomUniqueColor = (count) => {
  if (!count) {
    return [];
  }
  const colors = [
    "#E96F6F",
    "#FCC023",
    "#D63548",
    "#0979E4",
    "#AF8BAF",
    "#ADB842",
    "#9D402B",
    "#034249",
    "#4B83BB",
    "#D974A2",
    "#FF6362",
    "#900B3F",
    "#F2A364",
    "#A2C4C6",
    "#C39D4C",
    "#A1D981",
    "#FFA299",
    "#FFA299",
  ];

  if (count > colors.length) {
    for (let c = count - colors.length; c < count; c++) {
      let uniqColor;
      do {
        uniqColor = generateColor();
      } while (colors.indexOf(uniqColor) !== -1);
      colors.push(uniqColor);
    }
  }
  return colors;
};

export const getLineGraphFormat = (data, fillString) => {
  const filler = fillString ? " " : null;
  return [filler, ...data, filler];
};
